(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-section-type="cart-template"]');
    if (!section) return;

    function setRows(configId) {
      return Array.prototype.filter.call(section.querySelectorAll('[data-fk-config-id]'), function(row) {
        return row.getAttribute('data-fk-config-id') === configId;
      });
    }

    function orderSetRows() {
      var handled = {};
      Array.prototype.forEach.call(section.querySelectorAll('[data-fk-config-id]'), function(row) {
        var configId = row.getAttribute('data-fk-config-id');
        if (handled[configId]) return;
        handled[configId] = true;
        var rows = setRows(configId);
        var bag = rows.find(function(item) { return item.getAttribute('data-fk-role') === 'Tasche'; });
        var strap = rows.find(function(item) { return item.getAttribute('data-fk-role') === 'Gurt'; });
        if (!bag || !strap) return;
        strap.parentNode.insertBefore(bag, strap);
      });
    }

    orderSetRows();

    function updateSet(configId, quantity) {
      if (section.classList.contains('fk-set-is-updating')) return;
      var updates = {};
      setRows(configId).forEach(function(row) {
        updates[row.getAttribute('data-cart-item-key')] = quantity;
      });

      section.classList.add('fk-set-is-updating');
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      }).then(function(response) {
        if (!response.ok) throw new Error('Set konnte nicht aktualisiert werden.');
        window.location.reload();
      }).catch(function() {
        section.classList.remove('fk-set-is-updating');
        window.alert('Das konfigurierte Set konnte nicht aktualisiert werden. Bitte versuche es erneut.');
      });
    }

    section.addEventListener('change', function(event) {
      var input = event.target.closest('[data-quantity-input]');
      if (!input) return;
      var row = input.closest('[data-fk-config-id]');
      if (!row) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      updateSet(row.getAttribute('data-fk-config-id'), Math.max(0, parseInt(input.value, 10) || 0));
    }, true);

    section.addEventListener('click', function(event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      var row = remove.closest('[data-fk-config-id]');
      if (!row) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      updateSet(row.getAttribute('data-fk-config-id'), 0);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-bag-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fk-bag-configurator')) {
    class FkBagConfigurator extends HTMLElement {
      connectedCallback() {
        this.detailCopy = JSON.parse(this.querySelector('[data-fk-detail-copy]').textContent);
        this.recommendations = JSON.parse(this.querySelector('[data-fk-recommendations]').textContent);
        this.step = 0;
        this.styleWorld = null;
        this.product = null;
        this.variants = [];
        this.straps = JSON.parse(this.querySelector('[data-fk-strap-catalog]').textContent || '[]');
        this.selection = { metal: null, extra: null, strap: null };
        this.labels = ['Style', 'Tasche', 'Metall', 'Innentasche', 'Gurt', 'Prüfen'];
        this.nextLabels = ['Weiter zur Tasche', 'Weiter zu Metall', 'Weiter zur Innentasche', 'Weiter zum Gurt', 'Konfiguration prüfen', 'Tasche & Gurt in den Warenkorb'];
        this.setupNavigation();
        this.prepareModels();
        this.bind();
        this.renderStyles();
        if (!this.applyProductDeepLink()) {
          this.showInspiration();
          this.render();
        }
      }

      setupNavigation() {
        this.navigation = this.querySelector('[data-fk-navigation]');
        this.navigationPanel = this.querySelector('.fk-configurator__panel');
        this.floatingHost = document.createElement('div');
        this.floatingHost.className = 'fk-configurator';
        this.floatingHost.hidden = true;
        this.floatingNavigation = this.navigation.cloneNode(true);
        this.floatingNavigation.classList.add('is-floating');
        this.floatingNavigation.removeAttribute('data-fk-navigation');
        this.floatingNavigation.querySelector('[aria-live]').removeAttribute('aria-live');
        this.floatingNavigation.querySelector('[data-fk-error]').removeAttribute('role');
        this.floatingHost.appendChild(this.floatingNavigation);
        document.body.appendChild(this.floatingHost);
        ['back', 'next'].forEach((action) => {
          this.floatingNavigation.querySelector('[data-fk-' + action + ']').addEventListener('click', () => {
            this.navigation.querySelector('[data-fk-' + action + ']').click();
          });
        });
        this.updateNavigation = () => {
          if (this.navigationFrame) return;
          this.navigationFrame = requestAnimationFrame(() => {
            this.navigationFrame = null;
            const panel = this.navigationPanel.getBoundingClientRect();
            const original = this.navigation.getBoundingClientRect();
            const originalVisible = original.top >= 0 && original.bottom <= window.innerHeight;
            this.floatingHost.hidden = !(panel.top < window.innerHeight - 120 && panel.bottom > 120 && !originalVisible);
            ['summary', 'price', 'error', 'back', 'next'].forEach((name) => {
              const source = this.navigation.querySelector('[data-fk-' + name + ']');
              const target = this.floatingNavigation.querySelector('[data-fk-' + name + ']');
              target.textContent = source.textContent;
              target.hidden = source.hidden;
              target.title = source.title;
              if ('disabled' in source) target.disabled = source.disabled;
            });
          });
        };
        window.addEventListener('scroll', this.updateNavigation, { passive: true });
        window.addEventListener('resize', this.updateNavigation);
        this.navigationObserver = new MutationObserver(this.updateNavigation);
        this.navigationObserver.observe(this.navigation, { subtree:true, childList:true, characterData:true, attributes:true });
        this.updateNavigation();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateNavigation);
        window.removeEventListener('resize', this.updateNavigation);
        if (this.navigationObserver) this.navigationObserver.disconnect();
        if (this.navigationFrame) cancelAnimationFrame(this.navigationFrame);
        if (this.floatingHost) this.floatingHost.remove();
      }

      navigationSummary() {
        if (this.step === 0) return this.styleWorld ? '✓ ' + this.styleWorld + ' ausgewählt' : 'Bitte einen Style auswählen';
        if (this.step === 1) return this.product ? '✓ ' + this.product.title.replace(/\*NEU\*/gi, '').trim() + ' ausgewählt' : 'Bitte eine Tasche auswählen';
        if (this.step === 2) return this.selection.metal ? '✓ ' + this.selection.metal + ' ausgewählt' : 'Bitte eine Metallfarbe auswählen';
        if (this.step === 3) return this.selection.extra ? '✓ ' + this.extraLabel(this.selection.extra) : 'Bitte mit oder ohne Innenfach wählen';
        if (this.step === 4) return this.selection.strap ? '✓ ' + this.selection.strap.title + ' ausgewählt' : 'Bitte einen Gurt auswählen';
        return 'Bitte prüfe deine Kombination vor dem Hinzufügen';
      }

      modelWorlds(model) {
        try {
          const worlds = JSON.parse(model.dataset.styleWorlds || '[]');
          if (Array.isArray(worlds) && worlds.length && worlds.every((world) => typeof world === 'string' && world.trim())) {
            return [...new Set(worlds)];
          }
        } catch (exception) {}
        return model.dataset.styleWorld ? [model.dataset.styleWorld] : [];
      }

      prepareModels() {
        const products = new Map();
        this.models = [];
        this.querySelectorAll('[data-fk-model]').forEach((model) => {
          const key = model.dataset.productId || model.dataset.productHandle || model;
          const existing = products.get(key);
          if (existing) {
            existing.dataset.styleWorlds = JSON.stringify([...new Set([...this.modelWorlds(existing), ...this.modelWorlds(model)])]);
            const wrap = model.closest('[data-fk-model-wrap]');
            if (wrap) wrap.hidden = true;
            model.hidden = true;
          } else {
            products.set(key, model);
            this.models.push(model);
          }
        });
      }

      applyProductDeepLink() {
        const handle = new URLSearchParams(window.location.search).get('tasche');
        if (!handle) return false;
        const button = this.models.find((model) => model.dataset.productHandle === handle);
        if (!button) return false;
        this.styleWorld = button.dataset.styleWorld;
        this.querySelectorAll('[data-fk-model-wrap]').forEach((wrap) => {
          const model = wrap.querySelector('[data-fk-model]');
          wrap.hidden = !model || !this.models.includes(model) || !this.modelWorlds(model).includes(this.styleWorld);
        });
        this.querySelector('[data-fk-model-intro]').textContent = `${this.styleWorld}: ${button.dataset.productTitle} ist bereits ausgewählt.`;
        this.renderStyles();
        this.step = 2;
        this.selectProduct(button);
        const params = new URLSearchParams(window.location.search);
        const variant = this.variants.find((item) => String(item.id) === params.get('ausstattung'));
        if (variant) {
          this.selection.metal = variant.fkMetal;
          this.selection.extra = variant.fkExtra;
          this.selection.strap = this.availableStraps().find((item) => String(item.id) === params.get('gurt')) || null;
        }
        this.render();
        return true;
      }

      bind() {
        this.models.forEach((button) => button.addEventListener('click', () => this.selectProduct(button)));
        this.querySelector('[data-fk-back]').addEventListener('click', () => { if (this.step > 0) { this.step -= 1; this.render(); this.scrollToStep(); } });
        this.querySelector('[data-fk-next]').addEventListener('click', () => this.next());
      }

      worldDisplayName(world) {
        const names = { 'Holografisch': 'Glow & Gleam' };
        return names[world] || world;
      }

      renderStyles() {
        const target = this.querySelector('[data-fk-styles]');
        const descriptions = {
          'Cord': 'Weich, lässig und mit sichtbarer Struktur',
          'Animal Print': 'Leo, Zebra und ausdrucksstarke Muster',
          'Schlicht': 'Ruhige Farben und zeitlose Oberflächen',
          'Streifen': 'Grafisch, klar und modern',
          'Holografisch': 'Glänzend, schimmernd, reflektierend',
          'Struktur & Muster': 'Besondere Webungen und Oberflächen'
        };
        const worlds = ['Cord', 'Animal Print', 'Schlicht', 'Streifen', 'Holografisch', 'Struktur & Muster'];
        target.innerHTML = '';
        worlds.forEach((world) => {
          const count = this.models.filter((model) => this.modelWorlds(model).includes(world)).length;
          if (!count) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'fk-configurator__style';
          button.setAttribute('aria-pressed', String(this.styleWorld === world));
          button.innerHTML = `<strong>${this.escape(this.worldDisplayName(world))}</strong><small>${this.escape(descriptions[world])} · ${count} ${count === 1 ? 'Modell' : 'Modelle'}</small>`;
          button.addEventListener('click', () => this.selectStyle(world));
          target.appendChild(button);
        });
      }

      selectStyle(world) {
        this.styleWorld = world;
        this.product = null;
        this.variants = [];
        this.selection = { metal: null, extra: null, strap: null };
        this.models.forEach((model) => model.setAttribute('aria-pressed', 'false'));
        this.querySelectorAll('[data-fk-model-wrap]').forEach((wrap) => {
          const model = wrap.querySelector('[data-fk-model]');
          wrap.hidden = !model || !this.models.includes(model) || !this.modelWorlds(model).includes(world);
        });
        const introTexts = {
          'Holografisch': 'Glänzend, schimmernd, reflektierend – wähle jetzt dein Modell. Der passende Gurt kommt später dazu.'
        };
        this.querySelector('[data-fk-model-intro]').textContent = introTexts[world] || `${this.worldDisplayName(world)}: Wähle jetzt dein Modell. Der passende Gurt kommt später dazu.`;
        this.showInspiration(world);
        this.renderStyles();
        this.render();
      }

      showInspiration(world) {
        const models = this.models;
        const inspiration = models.find((model) => !world || this.modelWorlds(model).includes(world));
        const preview = this.querySelector('[data-fk-preview]');
        const empty = this.querySelector('[data-fk-empty]');
        const label = this.querySelector('[data-fk-visual-label]');
        this.querySelector('[data-fk-visual-note]').hidden = true;
        if (inspiration && inspiration.dataset.productImage) {
          preview.src = inspiration.dataset.productImage;
          preview.alt = world ? `Inspiration für den Style ${this.worldDisplayName(world)}` : 'Frau Kathl Taschen-Inspiration';
          preview.hidden = false;
          empty.hidden = true;
          label.textContent = world ? `Inspiration: ${this.worldDisplayName(world)}` : 'Inspiration';
        } else {
          preview.hidden = true;
          empty.textContent = world ? `Style ${this.worldDisplayName(world)} ausgewählt` : 'Wähle zuerst einen Style';
          empty.hidden = false;
          label.textContent = 'Inspiration';
        }
      }

      selectProduct(button) {
        this.models.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        const raw = button.querySelector('[data-fk-variants]').textContent;
        const rawImages = button.querySelector('[data-fk-images]').textContent;
        this.product = {
          title: button.dataset.productTitle,
          url: button.dataset.productUrl,
          image: button.dataset.productImage,
          handle: button.dataset.productHandle,
          images: JSON.parse(rawImages || '[]'),
          defaultMetal: button.dataset.defaultMetal
        };
        this.variants = JSON.parse(raw).filter((variant) => {
          if (!variant.available) return false;
          if (!/ohne\s+gurt/i.test(variant.title)) return false;
          if (/^(s|m|l|xl)\s*[|/]/i.test(variant.title)) return false;
          return true;
        });
        this.variants.forEach((variant) => {
          variant.fkMetal = this.metalFor(variant.title);
          variant.fkExtra = /innentasche/i.test(variant.title) && !/ohne\s+innentasche/i.test(variant.title) ? 'Mit Innentasche' : 'Ohne Innentasche';
        });
        this.selection = { metal: null, extra: null, strap: null };
        const preview = this.querySelector('[data-fk-preview]');
        preview.src = this.product.image;
        preview.alt = this.product.title;
        preview.hidden = false;
        this.querySelector('[data-fk-visual-label]').textContent = 'Produktvorschau';
        this.querySelector('[data-fk-visual-note]').hidden = false;
        this.querySelector('[data-fk-empty]').hidden = true;
        const error = this.querySelector('[data-fk-error]');
        if (this.variants.length === 0) {
          error.textContent = 'Für dieses Modell ist noch keine bestellbare Variante ohne Gurt angelegt.';
          error.hidden = false;
        } else {
          error.hidden = true;
        }
        this.render();
      }

      metalFor(title) {
        const parts = title.split(/\s*[|/]\s*/);
        const metal = parts.find((part) => !/gurt/i.test(part) && /(silber|gold)/i.test(part));
        if (!metal) return this.product.defaultMetal;
        return /silber/i.test(metal) ? 'Silberfarben' : 'Goldfarben';
      }

      availableVariants(filters = {}) {
        return this.variants.filter((variant) => {
          if (filters.metal && variant.fkMetal !== filters.metal) return false;
          if (filters.extra && variant.fkExtra !== filters.extra) return false;
          return true;
        });
      }

      values(key, filters) {
        return [...new Set(this.availableVariants(filters).map((variant) => variant[key]))];
      }

      createChoices(target, values, selected, handler, detailBuilder) {
        target.innerHTML = '';
        values.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'fk-configurator__choice';
          button.setAttribute('aria-pressed', String(value === selected));
          const detail = detailBuilder ? detailBuilder(value) : 'Verfügbar';
          button.innerHTML = `<strong>${this.escape(this.extraLabel(value))}</strong><small>${this.escape(detail)}</small>`;
          button.addEventListener('click', () => handler(value));
          target.appendChild(button);
        });
      }

      availableStraps() {
        if (!this.selection.metal) return [];
        return this.straps.filter((strap) => strap.metal === this.selection.metal);
      }

      renderStraps() {
        const target = this.querySelector('[data-fk-straps]');
        target.innerHTML = '';
        const straps = this.availableStraps();
        straps.forEach((strap) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'fk-configurator__strap';
          button.setAttribute('aria-pressed', String(this.selection.strap && String(this.selection.strap.id) === String(strap.id)));
          const image = strap.image ? `<img src="${this.escape(strap.image)}" alt="" loading="lazy">` : '<span></span>';
          const widthMatch = String(strap.variantTitle).match(/\b(\d{2})\s*mm\b/i);
          const width = widthMatch ? `${widthMatch[1]} mm · ` : '';
          const details = `${width}${strap.metal} · ${this.formatMoney(strap.price)}`;
          button.innerHTML = `${image}<span><strong>${this.escape(strap.title)}</strong><small>${this.escape(details)}</small></span>`;
          button.addEventListener('click', () => { this.selection.strap = strap; this.render(); });
          target.appendChild(button);
        });
        if (straps.length === 0 && this.selection.metal) {
          const message = document.createElement('p');
          message.textContent = 'Für diese Metallfarbe ist aktuell kein Gurt verfügbar.';
          target.appendChild(message);
        }
      }

      escape(value) {
        const span = document.createElement('span');
        span.textContent = value;
        return span.innerHTML;
      }

      selectedVariant() {
        return this.availableVariants({ metal: this.selection.metal, extra: this.selection.extra })[0] || null;
      }

      imageUrl(image) {
        if (!image) return '';
        return typeof image === 'string' ? image : (image.src || image.url || '');
      }

      extraLabel(value) {
        if (value === 'Mit Innentasche') return this.detailCopy.withPocket;
        if (value === 'Ohne Innentasche') return this.detailCopy.withoutPocket;
        return value;
      }

      recommendationImage() {
        if (!this.product || !this.selection.strap) return '';
        const preference = this.recommendations.find((item) => item.handle === this.product.handle);
        if (!preference || !preference.image) return '';
        const extra = preference.pocket === 'without' ? 'Ohne Innentasche' : 'Mit Innentasche';
        for (const variant of this.variants) {
          if (variant.fkExtra !== extra) continue;
          if (preference.metal && preference.metal !== 'auto' && preference.metal !== variant.fkMetal) continue;
          const strap = this.straps.find((item) => item.metal === variant.fkMetal &&
            (!preference.strapProductId || String(item.productId) === String(preference.strapProductId)) &&
            (!preference.strapVariant || item.variantTitle.trim().toLocaleLowerCase('de-DE') === preference.strapVariant.trim().toLocaleLowerCase('de-DE')));
          if (!strap) continue;
          const selected = this.selectedVariant();
          return selected && String(selected.id) === String(variant.id) && String(this.selection.strap.id) === String(strap.id) ? preference.image : '';
        }
        return '';
      }

      previewImage() {
        if (!this.product) return '';
        const combination = this.recommendationImage();
        if (combination) return combination;
        const variant = this.selectedVariant() || this.availableVariants({ metal: this.selection.metal })[0];
        const variantImage = variant && this.imageUrl(variant.featured_image);
        if (variantImage) return variantImage;
        const needle = this.selection.metal === 'Silberfarben' ? /silber/i : this.selection.metal === 'Goldfarben' ? /gold/i : null;
        if (needle) {
          const match = this.product.images.find((image) => needle.test(image.alt || ''));
          if (match) return match.url;
        }
        if (this.selection.metal === 'Silberfarben') {
          const goldIndex = this.product.images.findIndex((image) => /gold/i.test(image.alt || ''));
          const neutral = this.product.images.find((image, index) => index > goldIndex && !/gold/i.test(image.alt || ''));
          if (goldIndex !== -1 && neutral) return neutral.url;
        }
        return this.product.image;
      }

      updatePreview() {
        if (!this.product) return;
        const preview = this.querySelector('[data-fk-preview]');
        preview.src = this.previewImage();
        preview.alt = [this.product.title, this.selection.metal, this.recommendationImage() && this.selection.strap.title].filter(Boolean).join(' · ');
        this.querySelector('[data-fk-visual-note]').textContent = this.recommendationImage() ? this.detailCopy.combination : this.detailCopy.example;
        this.querySelector('[data-fk-visual-label]').textContent = this.selection.metal ? `Produktvorschau · ${this.selection.metal}` : 'Produktvorschau';
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
      }

      render() {
        this.querySelectorAll('[data-fk-step]').forEach((item) => item.classList.toggle('is-active', Number(item.dataset.fkStep) === this.step));
        this.querySelector('[data-fk-progress-copy]').textContent = `Schritt ${this.step + 1} von 6`;
        this.querySelector('[data-fk-progress-name]').textContent = this.labels[this.step];
        this.querySelector('[data-fk-progress-bar]').style.width = `${((this.step + 1) / 6) * 100}%`;
        this.querySelector('[data-fk-back]').disabled = this.step === 0;

        if (this.product) {
          const metals = this.values('fkMetal', {});
          if (!this.selection.metal && metals.length === 1) this.selection.metal = metals[0];
          this.createChoices(this.querySelector('[data-fk-metals]'), metals, this.selection.metal, (value) => {
            this.selection.metal = value; this.selection.extra = null; this.selection.strap = null; this.render();
          }, (value) => `${value}: Gurt-Schnallen, D-Ringe und Taschen-Reißverschluss`);

          const extras = this.values('fkExtra', { metal: this.selection.metal });
          this.createChoices(this.querySelector('[data-fk-extras]'), extras, this.selection.extra, (value) => {
            this.selection.extra = value; this.selection.strap = null; this.render();
          }, (value) => value === 'Mit Innentasche' ? '+10,00 € · mit eigenem Reißverschluss' : 'Kein Aufpreis');

          this.renderStraps();
          this.updatePreview();
        }

        const variant = this.selectedVariant();
        const strapTitle = this.selection.strap && this.selection.strap.title;
        const summary = [this.product && this.product.title, this.selection.metal, this.extraLabel(this.selection.extra), strapTitle].filter(Boolean).join(' · ');
        this.querySelector('[data-fk-summary]').textContent = this.navigationSummary();
        this.querySelector('[data-fk-summary]').title = summary;
        this.updateNavigation();
        const total = variant && this.selection.strap ? Number(variant.price) + Number(this.selection.strap.price) : null;
        this.querySelector('[data-fk-price]').textContent = total !== null ? this.formatMoney(total) : '';
        this.querySelector('[data-fk-next]').textContent = this.nextLabels[this.step];
        this.querySelector('[data-fk-next]').disabled = !this.canContinue();

        if (this.step === 5 && variant && this.selection.strap) {
          this.querySelector('[data-fk-review-image]').src = this.previewImage();
          this.querySelector('[data-fk-review-title]').textContent = this.product.title;
          const extraReview = this.extraLabel(this.selection.extra);
          this.querySelector('[data-fk-review-options]').textContent = [`Metallteile: ${this.selection.metal}`, extraReview].join(' · ');
          this.querySelector('[data-fk-review-strap]').textContent = `Gurt: ${this.selection.strap.title}`;
          this.querySelector('[data-fk-review-price]').textContent = this.formatMoney(total);
          const strapWrap = this.querySelector('[data-fk-review-strap-wrap]');
          const strapImg  = this.querySelector('[data-fk-review-strap-image]');
          if (strapWrap && strapImg) {
            strapImg.src = this.selection.strap.image || '';
            strapImg.alt = `${this.selection.strap.title} · ${this.selection.strap.metal}`;
            strapWrap.hidden = !this.selection.strap.image;
          }
        }
      }

      canContinue() {
        if (this.step === 0) return Boolean(this.styleWorld);
        if (this.step === 1) return Boolean(this.product && this.variants.length);
        if (this.step === 2) return Boolean(this.selection.metal);
        if (this.step === 3) return Boolean(this.selection.extra && this.selectedVariant());
        if (this.step === 4) return Boolean(this.selection.strap);
        return Boolean(this.selectedVariant() && this.selection.strap);
      }

      scrollToStep() {
        requestAnimationFrame(() => {
          const step = this.querySelector('[data-fk-step].is-active');
          const heading = step && step.querySelector('h2');
          if (!step) return;
          if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
          const header = document.querySelector('.site-header');
          const sticky = header && ['fixed', 'sticky'].includes(getComputedStyle(header).position);
          const offset = sticky ? header.getBoundingClientRect().height + 16 : 16;
          window.scrollTo({ top: Math.max(0, window.scrollY + step.getBoundingClientRect().top - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      }

      async next() {
        if (this.adding || !this.canContinue()) return;
        if (this.step < 5) { this.step += 1; this.render(); this.scrollToStep(); return; }
        const variant = this.selectedVariant();
        const button = this.querySelector('[data-fk-next]');
        const error = this.querySelector('[data-fk-error]');
        this.adding = true;
        this.querySelector('[data-fk-back]').disabled = true;
        button.disabled = true;
        button.textContent = 'Wird hinzugefügt …';
        error.hidden = true;
        try {
          const configurationId = `fk-${window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)}`;
          const shared = {
            '_fk_config_id': configurationId,
            Metall: this.selection.metal,
            Innentasche: this.selection.extra,
            Gurt: this.selection.strap.title
          };
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                { id: variant.id, quantity: 1, properties: { ...shared, Konfiguration: 'Frau Kathl Mix & Match', '_fk_role': 'Tasche' } },
                { id: this.selection.strap.id, quantity: 1, properties: { ...shared, 'Zu Tasche': this.product.title, '_fk_role': 'Gurt' } }
              ]
            })
          });
          if (!response.ok) {
            const failure = await response.json().catch(() => ({}));
            throw new Error(typeof failure.description === 'string' ? failure.description : 'Die Kombination konnte nicht hinzugefügt werden. Bitte prüfe die Verfügbarkeit und versuche es erneut.');
          }
          window.location.href = this.dataset.cartUrl;
        } catch (exception) {
          this.adding = false;
          this.querySelector('[data-fk-back]').disabled = false;
          error.textContent = exception.message === 'Failed to fetch' ? 'Verbindung unterbrochen. Bitte prüfe zuerst den Warenkorb, bevor du erneut hinzufügst.' : exception.message;
          error.hidden = false;
          button.disabled = false;
          button.textContent = this.nextLabels[this.step];
        }
      }
    }
    customElements.define('fk-bag-configurator', FkBagConfigurator);
  }

  } catch(e) { console.error(e); }
})();
})();
